import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/routes/shared/_api'

import {
  gtkyResponseSchema,
  GTKYRequestTypes,
  GTKYResponseTypes,
} from './schema'

type GTKYPayload = Omit<GTKYRequestTypes, 'id'> & {
  draft: boolean
}

const postGTKY = async (data: GTKYPayload): Promise<GTKYResponseTypes> => {
  const response = await api.post('/dashboard/profile/gtky', data)
  return gtkyResponseSchema.parse(response)
}

export const usePostGTKY = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: postGTKY,
    onSuccess: (data) => {
      queryClient.setQueryData(['gtky'], data)
      queryClient.invalidateQueries({
        queryKey: ['gtky'],
      })
    },
  })
}
